import { T, Translate } from '../../i18n/index';

export const CollectionTitle = {
	view(title: string): string {
		if (title == null || title === '') {
			return Translate(T.COLLECTION_MISSING_TITLE);
		}

		return title;
	},
};
